import { useState } from 'react';
import { Grid, Button, Box, TextField, Typography } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import FieldView2 from 'core/components/layout/FieldView2';
import { updateStitchingtaskInfo } from 'components/stitchingtask/StitchingtaskAPI';
import { updateStitchingtaskObj } from 'store/slice/ManufSlice';
import {setStitchingtaskEditRateModal} from 'store/slice/ManufSlice';

export default function EditRateActionImpl() {
    const dispatch = useDispatch();
    const { stitchingtaskObj } = useSelector((state) => state.manufslice.stitchingtaskDashboard);
    const [updatedRate, setUpdatedRate] = useState('');
    const [apiError, setApiError] = useState('');

    // Allow only decimal numbers
    const handleRateChange = (e) => {
        const value = e.target.value;
        if (/^\d*\.?\d*$/.test(value)) {
            setUpdatedRate(value);
        }
    };

    const handleSave = () => {
        setApiError('');
        if (updatedRate) {
            updateStitchingtaskInfo(
                stitchingtaskObj.id, { 
                    stitchingrate: parseFloat(updatedRate),
                    earning: parseFloat(updatedRate) * stitchingtaskObj.receivedqty,
                 },
                (response) => {
                    dispatch(updateStitchingtaskObj(response));
                    dispatch(setStitchingtaskEditRateModal(false));
                },
                (error) => {
                    setApiError(error|| 'Error updating rate');
                    console.error('Error updating rate:', error);
                }
            );
        }
    };

    return (
        <>
            <Grid container direction="row">
                <Grid item lg={8} sx={{ p: 2 }}>
                    <Box sx={{ backgroundColor: 'white', borderRadius: 2, p: 1 }}>
                        <Grid container direction="row">
                            <Grid item lg={6} xs={12}><FieldView2 label="Current Rate" value={stitchingtaskObj?.stitchingrate} /></Grid>
                            <Grid item lg={6} xs={12}><FieldView2 label="Worker" value={stitchingtaskObj?.workername} /></Grid>
                            <Grid item lg={6} xs={12}><FieldView2 label="Product" value={stitchingtaskObj?.productname} /></Grid>
                            <Grid item lg={6} xs={12}><FieldView2 label="Earnings" value={stitchingtaskObj?.earning} /></Grid>
                        </Grid>
                    </Box>
                </Grid>
                <Grid
                    item
                    lg={4}
                    sx={{
                        p: 2,
                        display: 'flex',
                        alignItems: 'flex-start', // Align to top
                        height: '100%',
                    }}
                >
                    <Grid container direction="column" alignItems="flex-end" justifyContent="flex-start">
                        <Grid item>
                            {/* <Typography variant="h6">Edit Rate</Typography> */}
                            <TextField
                                label="Updated Rate"
                                value={updatedRate}
                                onChange={handleRateChange}
                                type="text"
                                sx={{ backgroundColor: 'white', borderRadius: 2, width:'100%'  }}
                                inputProps={{ inputMode: 'decimal', pattern: '[0-9.]*' }}
                            />
                        </Grid>
                        <Grid item sx={{ mt: 2 }}>
                            <Button
                                variant="contained"
                                onClick={handleSave}
                                disabled={!updatedRate}
                            >
                                Save
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
                {apiError && (
                    <Grid item sx={{ p: 2 }}>
                        <Typography color="error" variant="body2">{apiError}</Typography>
                    </Grid>
                )}
            </Grid>
        </>
    );
}